import React, { useState , useEffect } from 'react'
import { Useglobelcontext } from './blogcontext/Blogcontext'
import { NavLink } from 'react-router-dom';
import styled from "styled-components";
import Filterblog from '../Filterblog';
import { FaTag } from "react-icons/fa6";
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';

function Blog() {

    const {duplicateblog  , showallblog , Allblogdata , allBlogloading} = Useglobelcontext();
    
       console.log(duplicateblog);
    const [currentpage , setcurrentpage] = useState(1);
  const itemperpage = 2;
  // calculate total pages 
  const totalpage = Math.ceil(duplicateblog.length / itemperpage);

   const currentdata = duplicateblog.slice(
    (currentpage -1 ) * itemperpage,
       currentpage * itemperpage
  );


    const [bannerData , setBannerImage] = useState([]);
    const [bannerLoading , setBannerLoading] = useState(true);
  
    useEffect(() => {
      const fetchBannerImage = async () => {
        try {
          setBannerLoading(true);
          const response = await fetch(`${BASE_URL}/banner/?page=blogpost`);
          const result = await response.json();
          setBannerImage(result.data[0]);
              } catch (error) {
                console.error('Error fetching banner:', error);
              } finally {
                setBannerLoading(false);
              }
            };
            
            fetchBannerImage();
          }, []);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalpage) {
      setcurrentpage(page);
    }
  };
  return (
   <>
   {
      bannerLoading && bannerData && bannerData.image ? (
        <SubLoading/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
       height:"50px"
     }}  
   
   data-overlay="title" data-opacity={8}>
  <div className="breadcumb-shape" data-bg-src="assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Blog Post</h1>
      <ul className="breadcumb-menu">
        <li><a href="/">Home</a></li>
        <li>Blog</li>
      </ul>
    </div>
  </div>
</div>

    )}
<section className="th-blog-wrapper space-top space-extra2-bottom">
  <div className="container">
    <div className="row gx-40">
      <div className="col-xxl-8 col-lg-7">
      <Wrapper>
      <div className="col-md result-count-container">
  <p className="woocommerce-result-count">
    Showing <span className="text-theme">{duplicateblog.length} courses</span> of <span onClick={showallblog} style={{cursor:"pointer",fontSize:"1.4rem" ,fontWeight:"bold",color:"green"}}>{Allblogdata.length}</span>
  </p>
</div>

{
  allBlogloading ? (
    <SubLoading/>
  ) :( <>   
        {
           currentdata.map((curdata , index)=>(
        <div  className="th-blog blog-single has-post-thumbnail" key={index} id="target-section">
          <div className="blog-img">
            
            <NavLink to={`/blogdetail/${curdata.slug}`}><img src={ curdata?.image ? `${BASE_URL}${curdata?.image}` :'/assets/img/AA_LOgo_Black.png'} alt="Blog Image" /></NavLink>
          </div>

          <div className="blog-content">
            <div className="blog-meta">
              <NavLink className="author" to="/blog"><i className="fa-light fa-user" />{curdata.author_name.author_name}</NavLink>
              <NavLink to="/blog"><i className="fa-light fa-clock" />{new Date(curdata.author_name.create_date).toLocaleDateString('en-CA')}</NavLink>
              <NavLink to={`/blogdetail/${curdata.slug}`}><i className="fa-light fa-book" />{curdata.blogcategory}</NavLink>
              <NavLink to={`/blogdetail/${curdata.slug}`}> <FaTag className='fa-light fa-tag'/> {curdata.tag}</NavLink>

            </div>

            <h2 className="blog-title"><NavLink to={`/blogdetail/${curdata.slug}`}>{curdata.title}</NavLink>
            </h2>

           <p
  className="blog-text"
  dangerouslySetInnerHTML={{
    __html:
      curdata.content.length > 200
        ? curdata.content.slice(0, 200) + '...'
        : curdata.content,
  }}
></p>


            <NavLink to={`/blogdetail/${curdata.slug}`} className="link-btn">Read More Details<i className="fas fa-arrow-right ms-2" /></NavLink>
          </div>
        </div>

      ))}
   </>)}
        </Wrapper>
<Wrapper>
<div className="th-pagination-container">
<div className="th-pagination text-center pt-50">
      <ul>
        {/* Previous Button */}
        <li>
          <button
            onClick={() => handlePageChange(currentpage - 1)}
            disabled={currentpage === 1}
          >
            <i className="far fa-arrow-left" />
          </button>
        </li>
        {/* Dynamic Page Numbers */}
        {Array.from({ length: totalpage },(_, index) => index + 1).map((page) => (
          <li key={page}>
            <button
              onClick={() => handlePageChange(page)}
              className={currentpage === page ? 'active' : ''}>
              {page}
            </button>
          </li>
        ))}
        {/* Next Button */}
        <li>
          <button
            onClick={() => handlePageChange(currentpage + 1)}
            disabled={currentpage === totalpage}
          >
            <i className="far fa-arrow-right" />
          </button>
        </li>
      </ul>
        </div>
        </div>
        </Wrapper>
        </div>
         {/* filter part of blog  */}
        <Filterblog/>
    </div>
  </div>
</section>
   </>
  )
}

const Wrapper =  styled.section`
  .blog-img img {
  width: 55rem;
  height: 26rem;
  }

  button{
  border: none;
}
.th-pagination-container {
  position: sticky;       /* Ensures the pagination stays in view */
  bottom: 0;              /* Positions it at the bottom of the section */
  background-color: #fff; /* Adds a background to prevent overlap */
  z-index: 10;            /* Keeps it above other content */
  padding: 10px 0;        /* Adds some spacing around the pagination */
  // box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow for clarity */
  
  }

.th-pagination {
  display: flex;
  justify-content: center; /* Centers the pagination buttons */
  gap: 10px;              /* Adds spacing between buttons */

}

.th-pagination ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap:1rem
}

.th-pagination ul li {
  margin: 0;
}

.th-pagination ul li button {
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.th-pagination ul li button.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.th-pagination ul li button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.result-count-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%; /* Adjust based on your layout */
}

.woocommerce-result-count {
  font-size: 1.2rem;
  color: #333;
  font-family: Arial, sans-serif;

}

.woocommerce-result-count .text-theme {
  color: #007bff; /* Theme color for the dynamic text */
  font-weight: bold;
}





`;

export default Blog